
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var DataActionUtil = require("../../../util/DataActionUtil.js");

class ExportStepButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        
        return <ActionButton 
                    {...this.props}
                    text="Export F3D"
                    mainClass="blue"
                    action={DataActionUtil.exportF3D}
                />
         

        return null;
    }
}

module.exports = ExportStepButton;